

import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { useEffect } from "react"
import textFilter from "../../../../helper/textFilter"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import yayinlamaSecenekleriOptions from "../../../../utils/yukOptions/yayinlamaSecenekleriOptions"
import { updateLoadPublishingType } from "../../../../features/updateLoad/updateLoadSlice"
import { showModal } from "../../../../features/modal/modalSlice"
import { setLoadItemData } from "../../../../features/loadList/loadListSlice"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainTextColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: ${({ theme }) => theme.mainTextColor};
        cursor: pointer;
        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }

        &:focus{
            cursor: text;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
        
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        color: ${({ theme }) => theme.mainTextColor};
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme}) => theme.mainTextColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }

        .active-option{
            border-top: 1px solid var(--color-main);
            border-bottom: 1px solid var(--color-main);
            background-color: #e8564639 !important;
        }
    }
`

const InputSelectLoadListYayinlamaOptions = ({data, labelText, name, inputWidth, loadItem}) => {
    
    const [text, setText] = useState(data)
    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)

    const [options, setOptions] = useState(yayinlamaSecenekleriOptions)

    //! her zaman state deki değeri al
    useEffect(() => {
        setText(data.text)
    },[data])

    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(!searchText){
            setOptions(yayinlamaSecenekleriOptions)
            // dispatch(handleActiveSelect(null))
        }

        else{
            const result = textFilter(yayinlamaSecenekleriOptions, searchText, "text")
            setOptions(result)
        }
        setText(searchText)
    }

    const handleOptionClick = (item) => {

        if(item.id !== 2){
            dispatch(handleActiveSelect(null))
            dispatch(updateLoadPublishingType({
                waitingLoadId: loadItem.id,
                publishingTypeId: item.id,
                scheduledPublishTimeHours: null,
            }))
        }
        else{
            dispatch(showModal("publishingType2"))
            dispatch(setLoadItemData(loadItem))
        }

    }

  return (
    <Container value={text} radius={"5px"} isActive={activeSelect === name} inputWidth={inputWidth} onClick={(e) => e.stopPropagation()}>
        <input type="text" id={"text"} onChange={handleChange} value={text} name={"text"} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        options.map((item) => (
                            <div key={item.id} className={data.id === item.id ? "option active-option" : "option"} onClick={() => handleOptionClick(item)}>
                                {item.text}
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputSelectLoadListYayinlamaOptions